import { useSelector } from 'react-redux';

import { UserBase, UserContactType } from '@lib/resources/types';
import { selectCurrentMasterSettings } from '@lib/selectors';
import { trackEvent } from '@lib/services/eventsService';

export default function useTrackAppointmentRequested() {
  const masterSettings = useSelector(selectCurrentMasterSettings);

  return (user?: UserBase | null) => {
    if (
      user &&
      !!masterSettings?.reporting?.googleAnalytics?.publishPatientDetails &&
      user.roles?.includes('patient')
    ) {
      const phone = user.contact.find(
        (userContact) => userContact.type === UserContactType.Sms || userContact.type === UserContactType.Voice,
      )?.value;
      const email = user.contact.find((userContact) => userContact.type === UserContactType.Email)?.value;

      trackEvent({
        event: 'Appointment_Requested',
        phone,
        email,
      });
    }
  };
}
